import React from 'react';

const MatchbackDateIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.7497 0.75V2.41667" stroke="#818181" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.08366 0.75V2.41667" stroke="#818181" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.75 4.91667H14.0833" stroke="#818181" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.0833 8.59748V3.24998C14.0833 2.32915 13.3375 1.58331 12.4167 1.58331H2.41667C1.49583 1.58331 0.75 2.32915 0.75 3.24998V12.4166C0.75 13.3375 1.49583 14.0833 2.41667 14.0833H8.5975"
        stroke="#818181"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.08283 7.20833C3.96783 7.20833 3.87449 7.30167 3.87533 7.41667C3.87533 7.53167 3.96866 7.625 4.08366 7.625C4.19866 7.625 4.29199 7.53167 4.29199 7.41667C4.29199 7.30167 4.19866 7.20833 4.08283 7.20833"
        stroke="#818181"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.08283 10.5416C3.96783 10.5416 3.87449 10.635 3.87533 10.75C3.87533 10.865 3.96866 10.9583 4.08366 10.9583C4.19866 10.9583 4.29199 10.865 4.29199 10.75C4.29199 10.635 4.19866 10.5416 4.08283 10.5416"
        stroke="#818181"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.20833 7.4175C7.20833 7.5325 7.30167 7.62583 7.41667 7.625C7.53167 7.625 7.625 7.53166 7.625 7.41666C7.625 7.30166 7.53167 7.20833 7.41667 7.20833C7.30167 7.20833 7.20833 7.30166 7.20833 7.4175"
        stroke="#818181"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4167 16.5833C10.1158 16.5833 8.25 14.7183 8.25 12.4167C8.25 10.1633 10.1667 8.2475 12.42 8.25C14.72 8.25167 16.5833 10.1167 16.5833 12.4167C16.5833 14.7175 14.7183 16.5833 12.4167 16.5833"
        stroke="#818181"
        strokeWidth="1.5"
      />
      <path
        d="M12.4167 10.75V14.0833"
        stroke="#818181"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0833 12.4167H10.75"
        stroke="#818181"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MatchbackDateIcon;
